module.exports = __webpack_public_path__ + "static/media/utsushimi-camie-win.52eaf4d3.png";